import React from 'react';

interface IProps {
    className: string;
    children: React.ReactNode;
    testId?: string;
}

const SubContent = ({ className, children, testId } :IProps) => (
  <div className={className} data-testid={testId}>
    {children}
  </div>
);

export default SubContent;
